import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { OnInit, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-photo-gallery',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './photo-gallery.component.html',
  styleUrl: './photo-gallery.component.scss'
})
export class PhotoGalleryComponent implements OnInit {

  constructor(private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/photo-gallery",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);


    this.titleService.setTitle('NCARE IVF Photo Gallery | Explore Our Facility & Patient Moments');
    this.metaService.updateTag({
      name: 'description',
      content: 'Take a visual tour of NCARE IVF Centre in Kannur through our photo gallery. View our advanced fertility center, treatment facilities, and heartwarming patient moments captured on camera.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'IVF Clinic Photo Gallery, NCare IVF Kannur, Kerala Images, Fertility Center Tour, IVF Facilities Kannur, Patient Experience Photos'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'NCARE IVF Photo Gallery | Explore Our Facility & Patient Moments'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Take a visual tour of NCARE IVF Centre in Kannur through our photo gallery. View our advanced fertility center, treatment facilities, and heartwarming patient moments captured on camera.'
    });
  }

}
